<template>
  <div>
    <el-date-picker
      popper-class="custom-date-picker"
      size="mini"
      v-model="period"
      style="margin-bottom: 20px;"
      prefix-icon="el-icon-date"
      type="daterange"
      align="center"
      format="d MMM yy"
      value-format="timestamp"
      range-separator=""
      start-placeholder="Start date"
      end-placeholder="End date"
      @change="setFilter($event)"
      :picker-options="pickerOptions">
    </el-date-picker>

    <el-table
      max-height="600"
      :data="tableData"
      :empty-text="$t('general_noData')"
      style="width: 100%">
      <el-table-column align="center" label="Taxable Month" width="150">
        <template slot-scope="scope">
          <div v-html="scope.row.taxablemonth"></div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="TIN" width="200">
        <template slot-scope="scope">
          <div v-html="scope.row.tin"></div>
        </template>
      </el-table-column>
      <el-table-column label="Registered Name">
        <template slot-scope="scope">
          <div v-html="scope.row.registeredname"></div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="Name of Client" width="200">
        <template slot-scope="scope">
          <div v-html="scope.row.customername"></div>
        </template>
      </el-table-column>
      <el-table-column label="Client Address" width="300">
        <template slot-scope="scope">
          <div v-html="scope.row.customeraddress"></div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="right" label="Amount of Gross Sales" width="150">
        <template slot-scope="scope">
          <div>{{ formatPrice(scope.row.grossamount) }}</div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="right" label="Amount of Exempt Sales" width="150">
        <template slot-scope="scope">
          <div>{{ formatPrice(scope.row.exemptsales) }}</div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="right" label="Amount of Zero Rated Sales" width="150">
        <template slot-scope="scope">
          <div>{{ formatPrice(scope.row.zeroratedsales) }}</div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="right" label="Amount of Taxable Sales" width="150">
        <template slot-scope="scope">
          <div>{{ formatPrice(scope.row.taxablesales) }}</div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="right" label="Amount of Output Tax" width="150">
        <template slot-scope="scope">
          <div>{{ formatPrice(scope.row.outputamount) }}</div>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="right" label="Amount of Gross Taxable Sales" width="150">
        <template slot-scope="scope">
          <div>{{ formatPrice(scope.row.grosstaxablesales) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="Report" align="center" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.reported">
            <el-checkbox disabled v-model="scope.row.reported"></el-checkbox>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  export default {
    data() {
      return {
        moment:moment,

        tableData: [],

        period: null,
        pickerOptions: {
          shortcuts: [{
            text: 'This month',
            onClick(picker) {
              const end = moment().endOf('month');
              const start = moment().startOf('month');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = moment().endOf('month').subtract(1, 'months');
              const start = moment().startOf('month').subtract(1, 'months');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = moment().endOf('month').subtract(1, 'months');
              const start = moment().startOf('month').subtract(3, 'months');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'This financial quarter',
            onClick(picker) {
              const end = moment().endOf('quarter');
              const start = moment().startOf('quarter');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last financial quarter',
            onClick(picker) {
              const end = moment().subtract(1, 'quarter').endOf('quarter');
              const start = moment().subtract(1, 'quarter').startOf('quarter');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'This financial year',
            onClick(picker) {
              const end = moment().endOf('year');
              const start = moment().startOf('year');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last financial year',
            onClick(picker) {
              const end = moment().endOf('year').subtract(1, 'year');
              const start = moment().startOf('year').subtract(1, 'year');
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    methods: {
      setFilter(event) {
        this.loadList()
      },
      loadList() {
        const startDate = !this.period ? null : moment(this.period[0]).format('MM-DD-YYYY')
        const endDate = !this.period ? null : moment(this.period[1]).format('MM-DD-YYYY')
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/account/summaryListOfSales?companyId=${this.$route.query.companyId}&startDate=${startDate}&endDate=${endDate}`)
          .then(response => {
            console.log("🚀 ~ loadList ~ response:", response)
            this.tableData = response.data.data
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          })
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>